<div
  class="nav-list-item-container fs-12px fw-500 text-color-gray-9 hov-cursor-p centered-vert d-flex"
  [uiTooltipTitle]="item.title"
  [uiTooltipTrigger]="isTitleOverflowing ? 'hover' : null"
  [cdkDragDisabled]="config.itemsGroupType !== 'favorites'"
  [class.menu-opened]="isMenuOpened"
  ui-tooltip
  uiTooltipPlacement="right"
  tabindex="-1"
  cdkDragBoundary=".drag-area"
  cdkDrag
  cdkDragRootElement="nav-list-item">
  <div class="drag-handle gh-font-icon-move fs-14px hov-cursor-g h-28px w-24px flex-n pl-4px pt-6px" *ngIf="config.itemsGroupType === 'favorites'" cdkDragHandle></div>
  <nav-list-item-icon [itemsType]="config.itemsType" [item]="item"></nav-list-item-icon>
  <div
    class="item-title ellipsis pt-5px mr-3px h-28px flex-a"
    [attr.id]="item.id"
    [ngClass]="{ active: isActive }"
    [attr.data-test-id]="'item-sub-nav-section-' + config.itemsGroupType"
    (click)="view(item)">
    {{ item.title }}
  </div>
  <nav-list-item-context-menu
    [item]="item"
    [config]="{ itemsType: config.itemsType, itemsGroupType: config.itemsGroupType, broadcastConfig: config.broadcastConfig.navItemContextMenuActions }"
    (menuToggled)="onMenuToggled($event)"
    (markItemAsFavorite)="markItemAsFavorite.emit($event)"
    (unmarkItemAsFavorite)="unmarkItemAsFavorite.emit($event)"
    (removeFromSuggested)="removeFromSuggested.emit($event)">
  </nav-list-item-context-menu>
  <div class="grey-background"></div>
</div>
